/**
 * Formats marker text by splitting on '|' character and creating HTML with line breaks
 * @param {string} markerText - The original marker text
 * @returns {string} HTML string with parts separated by <br> tags
 */
export function formatMarkerText(markerText) {
  if (!markerText || typeof markerText !== 'string') {
    return markerText || ''
  }
  
  // Split on '|' character and filter out empty parts
  const parts = markerText.split('|').filter(part => part.trim().length > 0)
  
  // Join parts with HTML line breaks
  return parts.join('<br>')
}